/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetOrganizationLicenseFinancials = require('../services/GetOrganizationLicenseFinancials');
var GetOrganizationLicenseIdentifiers = require('../services/GetOrganizationLicenseIdentifiers');
var SecOrganizationLicenseFinancialsDashboardView = require('../views/SecOrganizationLicenseFinancialsDashboardView');

module.exports = function(organizationId, licenseId, financialsId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetOrganizationLicenseIdentifiers(licenseId), GetOrganizationLicenseFinancials(financialsId))
    .done(function(identifiers, financials) {
      NavUtils.navigate(
        '#sec/organization/' + organizationId + '/license/' + licenseId + '/financials/' + financialsId + '/dashboard'
      );
      Scaffold.content.show(
        new SecOrganizationLicenseFinancialsDashboardView({
          model: new Backbone.Model({
            organizationId: organizationId,
            licenseId: licenseId,
            identifiers: identifiers,
            financials: financials
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
